module.exports = __webpack_public_path__ + "img/bannerRed.7e0fff42.jpg";